import React, { useEffect, useState, useCallback, useRef } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import moment from 'moment';
import Swal from 'sweetalert2';
import Select from 'react-select';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import useUserStore from '../../stores/Users';
import LoadingView from '../../components/Loading';
import Icon from '../../components/Icon';
import Card from '../../components/SimpleCard';
import axios from 'axios';
import { baseAPI } from '../../services/baseAPI';

function ApprovalAjuanTabung() {
  const { id, iduser } = useParams();
  const history = useHistory();
  const ADMIN = 1;
  const USP = 3;
  const token = useUserStore((state) => state.token);
  const user = useUserStore((state) => state.user);

  const [isLoading, setIsLoading] = useState(true);
  const [newData, setNewData] = useState([{
    tgl_mulai: "",
    jangka:0,
    setoran: "",
    total: "",
    no_rekening: "",
    nama_bank: "",
    atas_nama: "",
  }]);
  const [listTargetTabungan, setListTargetTabungan] = useState([
    { label: "Rp.1.000.000", value: 1000000 },
    { label: "Rp.2.000.000", value: 2000000 },
    { label: "Rp.3.000.000", value: 3000000 },
    { label: "Rp.4.000.000", value: 4000000 },
    { label: "Rp.5.000.000", value: 5000000 },
    { label: "Rp.6.000.000", value: 6000000 },
    { label: "Rp.7.000.000", value: 7000000 },
    { label: "Rp.8.000.000", value: 8000000 },
    { label: "Rp.9.000.000", value: 9000000 },
    { label: "Rp.10.000.000", value: 10000000 },
  ]);
  const [empTargetTabungan, setEmpTargetTabungan] = useState([]);
  const [listLamaTabungan, setListLamaTabungan] = useState([
    { label: "6 - Bulan", value: 6 },
    { label: "12 - Bulan", value: 12 },
    { label: "18 - Bulan", value: 18 },
    { label: "24 - Bulan", value: 24 },
  ])
  const [empLamaTabungan, setEmpLamaTabungan] = useState(0);
  const [empSetorTabungan, setEmpSetorTabungan] = useState([]);
  const [dataAjuan, setDataAjuan] = useState([]);
  const [empData, setEmpData] = useState([]);
  const [tabungRate, setTabungRate] = useState([]);



  // CONTROLLER
  const fetchData = async (id, iduser) => {
    setIsLoading(true);
    await axios
      .all(
        [
        baseAPI .get(`/v1/user/${iduser}`, { headers: { Authorization: `Bearer ${token}` } }),
        baseAPI .get(`/v1/tabungrate`, { headers: { Authorization: `Bearer ${token}` } }),
        baseAPI .get(`/v1/ajuantabung/${id}`, { headers: { Authorization: `Bearer ${token}` } }),  
      ]
      )
      .then((res) => {
        const data = res[0].data.data.userData;       
        const tabungRate = res[1].data.data.tabungrate;       
        const ajuanTabung = res[2].data.data.ajuantabung;  

        let target = [];
        listTargetTabungan.map(e => {
          if (e.value == ajuanTabung[0].total) {
            target.push({ label: e.label, value: e.value })
          }
        });

        let lama = [];
        listLamaTabungan.map(e => {
          if (e.value == ajuanTabung[0].jangka) {
            lama.push({ label: e.label, value: e.value })
          }
        });

        setEmpData(data[0]);
        setEmpLamaTabungan(lama[0]);
        setEmpTargetTabungan(target[0]);
        setEmpSetorTabungan("Rp." + parseFloat(ajuanTabung[0].setoran).toLocaleString('id-ID'));
        setTabungRate(tabungRate);
        setDataAjuan(ajuanTabung[0]);
      })
      .catch((error) => {
        setIsLoading(false);
        Swal.fire({
          icon: 'error',
          title: `Gagal mengambil data`,
          showConfirmButton: false,
          timer: 1500
        })
        console.log(`error ${error}`);
      })
      .finally(() => {
        setIsLoading(false);
        alert("Maksimal approval adalah tanggal 2 setiap bulannya, agar setoran pertama dilakukan pada tanggal 25 di bulan yang sama.");
      })
  };

  const updateAjuanTabung = async (idAjuan, status) => {

    Swal.fire({
      title: 'Apakah anda akan ' + status + ' ajuan tabungan ini?',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: 'Ya',
    }).then((result) => {
      if (result.isConfirmed) {
        setIsLoading(true);

        const body = new FormData();
        body.append('update_data', JSON.stringify(dataAjuan));
        body.append('status', status == "menyetujui" ? "Disetujui" : "Ditolak");

        baseAPI
          .put(`/v1/ajuantabung/${idAjuan}`, body, {
            headers: {
              Accept: 'application/json',
              Authorization: `Bearer ${token}`,
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => {
            Swal.fire({
              icon: 'success',
              title: "Data pengajuan tabungan berhasil diperbarui.",
              showConfirmButton: false,
              timer: 1500
            })
            // fetchData(id, iduser);
            console.log(`berhasil upload ${JSON.stringify(res)}`);
          })
          .catch((error) => {
            setIsLoading(false);
            console.log('error: ', error);
            Swal.fire({
              icon: 'error',
              title: "Data pengajuan tabungan gagal diperbarui.",
              showConfirmButton: false,
              timer: 1500
            })
          })
          .finally(() => {
            setIsLoading(false);
            fetchData(id, iduser);
          })
      }
    });

  }

  const checkCicilanTabungan = (jangka, target) => {
    if (jangka != 0) {
      // let hitung = (target / jangka).toFixed(0);

      let matchedRate = null;

      // Find the matching rate
      tabungRate.some(e => {
        if (e.plafond === target && e.tenor === jangka) {
          matchedRate = e;
          return true; // Stop iterating after the first match
        }
        return false;
      });
      
      if (matchedRate) {
        let hitung = (matchedRate.cicilan).toFixed(0);
        let rupiahFormat = parseFloat(hitung).toLocaleString('id-ID'); // 'id-ID' is the locale for Indonesian Rupiah

        setEmpSetorTabungan("Rp." + rupiahFormat);
        setDataAjuan({...dataAjuan, jangka: jangka, total: target, setoran: hitung});
      }
    }
  }

  useEffect(() => {
    if (user.role === USP) {
      fetchData(id, iduser);
    };
  }, [token]);
  

  // VIEW

  const headerView = () => (
    <div className='page-header'>
      <div className='row align-items-center'>
        {/* Title */}
        <div className='col'>
          <ol className='breadcrumb'>
            <li className='breadcrumb-item Navbar_title'>
              <Link to='#' style={{ color: '#333' }}>Data Tabungan</Link> /{' '}
              <Link to='/datatabungan/listpengajuantabungan' style={{ color: '#333' }}>List Pengajuan Tabungan</Link> /{' '}
              <Link to='#' style={{ color: '#333' }}>Approval Ajuan Tabungan</Link>
            </li>
          </ol>
        </div>
      </div>
    </div>
  );

  const parsedDate = moment(dataAjuan.created_at, "YYYY-MM-DD HH:mm:ss");
  const defaultDate = parsedDate.isValid() ? parsedDate.toDate() : null;

  const addView = () => (
    <div className='row row-deck row-cards'>
      <div className='col-md-12'>
        <div className='card'>
          <div className='card-body'>
            <div className='row'>
              <div className='mb-3'>
                <p style={{fontSize: 25}}><b>Approval Pengajuan Tabungan</b></p>
                <p>Silahkan cek ajuan tabungan berikut, dan berikan keputusan anda sebagai USP.</p>
              </div>

              {/* Target tabungan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Prakira Target Tabungan
                </label>
                <Select
                  options={listTargetTabungan}
                  defaultValue={listTargetTabungan && empTargetTabungan}
                  placeholder="Pilih target"
                  onChange={e => {
                    setEmpTargetTabungan(e.label)
                    setDataAjuan({...dataAjuan, total: e.value})
                    checkCicilanTabungan(dataAjuan.jangka, e.value);
                  }}
                />
              </div>

              {/* Lama Tabungan */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Prakira Lama Tabungan
                </label>
                <Select
                  options={listLamaTabungan}
                  defaultValue={listLamaTabungan && empLamaTabungan}
                  placeholder="Pilih jangka tabungan"
                  onChange={e => {
                    setEmpLamaTabungan(e.value)
                    setDataAjuan({...dataAjuan, jangka: e.value})
                    checkCicilanTabungan(e.value, dataAjuan.total);
                  }}
                />
              </div>

              {/* Besar setoran */}
              <div className='col-md-6 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Besar Setoran
                </label>
                <input
                  value={empSetorTabungan}
                  readOnly
                  placeholder='Target tabungan'
                  className="form-control"
                />
              </div>

              {/* Name */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Name
                </label>
                <input
                  defaultValue={empData.name_anggota}
                  readOnly
                  placeholder='Employee name'
                  className="form-control"
                />
              </div>

              {/* No Rekening */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  No Rekening
                </label>
                <input
                  value={empData.no_rekening}
                  readOnly
                  placeholder='Nomor rekening'
                  className="form-control"
                />
              </div>

              {/* Tanggal pengajuan */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Tanggal Pengajuan
                </label>
                <DatePicker
                  selected={defaultDate}
                  placeholderText="Pilih tanggal"
                  className="form-control datepicker"
                  dateFormat="dd/MM/yyyy"
                  readOnly
                  // onChange={(date) => {
                  //   // console.log("Selected Date:", date); // Add this line for debugging
                  //   setDataAjuan({...dataAjuan, created: date });
                  // }}
                />

              </div>

              {/* No rekening pencairan */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  No Rekening Pencairan
                </label>
                <input
                  defaultValue={dataAjuan.no_rekening}
                  required
                  placeholder='Rekening pencairan'
                  className="form-control"
                  onChange={e => setDataAjuan({...dataAjuan, no_rekening: e.target.value})}
                />
              </div>
              
              {/* Nama bank */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Nama Bank
                </label>
                <input
                  defaultValue={dataAjuan.nama_bank}
                  required
                  placeholder='Nama bank'
                  className="form-control"
                  onChange={e => setDataAjuan({...dataAjuan, nama_bank: e.target.value})}
                />
              </div>
              
              {/* Atas nama rekening pencairan */}
              <div className='col-md-3 mb-3'>
                <label htmlFor='true' className='form-label'>
                  Atas Nama Rekening Pencairan
                </label>
                <input
                  defaultValue={dataAjuan.atas_nama}
                  required
                  placeholder='Atas nama'
                  className="form-control"
                  onChange={e => setDataAjuan({...dataAjuan, atas_nama: e.target.value})}
                />
              </div>
              
              <div className='col-md-6'>
                <button
                  disabled={dataAjuan.no_rekening !== "" && dataAjuan.nama_bank !== "" && dataAjuan.atas_nama !== "" ? false : true}
                  type="button"
                  className='btn btn-success col-md-12'
                  style={{backgroundColor: "#6A9C89"}}
                  onClick={() => updateAjuanTabung(dataAjuan.id, "menyetujui")}
                >
                  Setujui
                </button>
              </div>

              <div className='col-md-6'>
                <button
                  disabled={dataAjuan.no_rekening !== "" && dataAjuan.nama_bank !== "" && dataAjuan.atas_nama !== "" ? false : true}
                  type="button"
                  className='btn btn-danger col-md-12'
                  onClick={() => updateAjuanTabung(dataAjuan.id, "menolak")}
                >
                  Tolak
                </button>
              </div>

              <div className='col-md-12'>
                <p className='text-danger'>
                  Maksimal approval tanggal 2 setiap bulan, agar setoran pertama di tanggal 25 di bulan yang sama.
                  Jika approval lebih dari tanggal 2, maka setoran pertama dilakukan pada tanggal 25 bulan berikutnya.
                </p>
              </div>

            </div>
          </div>
        </div>
      </div>

    </div>
  )

  return (
    <div className='container-fluid'>
      
      {headerView()}
      
      {isLoading ? <LoadingView /> : addView()}
      {/* {addView()} */}

    </div>
  );

}

export default ApprovalAjuanTabung;